import AccountPage from './pages/AccountPage.vue';

const routes = [
  {
    path: '/account',
    name: 'store-account',
    component: AccountPage,
    meta: {
      title: 'Mon Compte - Kingrecharges Store',
    }
  },
];

export default routes;
